import './AuthTitle.css';

const AuthTitle = ({ children }) => {
  return <h1 className="auth-title">{children}</h1>;
};

export default AuthTitle;
